import globalzoom from "../../../../assets/images/docs/globalzoom.png";
import * as React from 'react';
export default {
  globalzoom,
  React
};